import { useState } from 'react'

import btcIcon from '@Static/images/currencies/btc.png'
import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import { formatDate, formatTime, useTrades } from '../../../../model'
import { Card } from '../Card'

import s from './styles.module.scss'

enum SortBy {
  Volume = 'volume',
  Number = 'number',
}
const options = [
  { name: 'Trading volume', value: SortBy.Volume },
  { name: 'Number of trades', value: SortBy.Number },
]

export const PopularTrades = () => {
  const [sortBy, setSordBy] = useState(SortBy.Volume)
  const selectedSort = options.find((op) => op.value === sortBy)
  const { trades } = useTrades()
  const closedTrades = trades.filter((v) => v.status === 'closed')

  return (
    <Card
      className={s.container}
      title="Most popular with other traders"
      contentClassName={s.content}
      headerRightElement={
        <Select
          value={sortBy}
          options={options}
          containerClassName={s.selectContainer}
          inputClassName={s.select}
          optionClassName={s.option}
          onChange={(val) => setSordBy(val as SortBy)}
        />
      }
    >
      <div className={s.header}>
        <div className={s.segment}>Market</div>
        <div className={cn(s.segment, s.end)}>{selectedSort?.name}</div>
      </div>
      <div className={s.trades}>
        {closedTrades.map((trade) => (
          <div key={trade.id} className={s.trade}>
            <div className={cn(s.segment, s.left)}>
              <img src={btcIcon} className={s.icon} alt="btc" />
              <div className={s.content}>
                <div className={s.name}>
                  {trade.market.source}/{trade.market.target}
                </div>
                <div className={s.date}>
                  {formatDate(trade.open_time)} {formatTime(trade.open_time)}
                </div>
              </div>
            </div>
            <div className={cn(s.segment, s.right, trade.result < 0 && s.negative)}>
              {getValueWithCurrency(trade.market.target, trade.result)}
            </div>
          </div>
        ))}
      </div>
    </Card>
  )
}
